var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78064 0.205941C9.05958 -0.0686465 9.51185 -0.0686465 9.79079 0.205941C10.0697 0.480528 10.0697 0.925722 9.79079 1.20031L5.50508 5.41906C5.23466 5.68525 4.79925 5.69456 4.51734 5.44019L0.23163 1.573C-0.0591694 1.3106 -0.078815 0.865823 0.187751 0.579568C0.454318 0.293312 0.906151 0.273975 1.19695 0.536376L4.97852 3.94865L8.78064 0.205941Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.be8bf322b325a586fc71e3ddf09af446.svg";
export { ForwardRef as ReactComponent };